<template>
  <ion-content>
    <section class="section bg-gradient-animated novi-background p-sm-0"
             data-preset='{"title":"Intro","category":"intro","reload":false,"id":"intro-6"}'>
      <div class="container">

        <section class="section " style="margin-top: 0; padding-top: 1em">
          <div class="container">
            <!-- Breadcrumb-->
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link " to="/"><h5>My Account</h5></router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link breadcrumb-active" to="/documents/"><h5>Documents</h5></router-link>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </section>
    <section class="section  novi-background">
      <div class="container">
<!--        <h2 class="text-center">Documents</h2>-->
        <p>Please select and upload the required documents using the below options. During the different stages of the process we may request different documents from you.</p>
        <p>This may include yours and your partners CV, education qualifications, bank statements, passport copies etc. It is important to us to have accurate and up to date information about you, and your partner to process your application</p>
        <div class="row row-30">
          <div v-for="doc in documents" v-bind:key="doc.code" class="col-sm-6 col-lg-4">
            <!-- Offer box light-->
            <div class="article-box-large offer-box offer-box-light">
              <h5 class="offer-box-title">{{ doc.title }}</h5>
              <div class="offer-box-divider"></div>
              <div class="offer-box-text">{{ doc.details }}</div>
              <ul class="offer-box-list mb-3">
                <li v-for="docu in getDocUploads(doc.code)" v-bind:key="docu.id">
                  <!--                  <div class="icon icon-round icon-sm icon-primary-filled fa-television novi-icon"></div>-->
                  <div class="row">
                    <div class="icon icon-md icon-secondary mdi-file-pdf novi-icon"></div>
                    <div class="col">
                      <span class="offer-box-list-text">{{ docu.title }}</span>
<!--                      <br>-->
<!--                      <span class="offer-box-list-text text-500 small">{{ docu.url }}</span>-->
                      <br>
<!--                      <span class="offer-box-list-text text-500">{{docu.timeid | formatTimeId('yyyy-MMM-DD hh:mm A') }}</span>-->
                    </div>
<!--                    <div class="icon icon-md icon-primary mdi-eye novi-icon"></div>-->
                    <div v-on:click="toDelete = docu" class="icon icon-md icon-warning mdi-delete novi-icon"></div>
                  </div>
                  <div v-if="toDelete === docu" class="row novi-disabled mt-0 mb-4">
                    <div class="col">
                      <div class="alert alert-danger">
                        <div class="alert-inner">
                          <div class="alert-inner-item">
                            <p class="alert-title"><span class="icon alert-icon novi-icon int-info"></span>Are you sure
                              you want to delete the file</p>
                          </div>
                          <div class="alert-inner-item">
                            <div class="alert-inner-controls">
                              <button v-on:click="deleteDocument(docu)" class="btn btn-danger">YES</button>
                              <button v-on:click="toDelete = null" class="btn btn-warning">NO</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <file-upload class="mb-2" v-for="docrule in getDocumentRules(doc)" :key="docrule.id" :docrule="docrule"
                           :doctype="doc" v-on:on-upload="updateDocuments"></file-upload>
              <file-upload v-if="!doc.rules || doc.rules.length === 0 " :doctype="doc" v-on:on-upload="updateDocuments"></file-upload>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ion-content>
</template>

<script>
import EoppService from "@/mixins/EoppService";
import FileUpload from "@/account/pages/FileUpload";
import {IonContent} from "@ionic/vue";

export default {
  name: "Documents",
  components: {
    FileUpload,
    IonContent
  },
  mixins: [EoppService],
  data() {
    return {
      documents: [],
      uploaded: [],
      toDelete: null
    }
  },
  methods: {
    getDocumentRules: function (doc) {
      //return the list of document rules which required but not yet uploaded
      return (doc.value || []).filter(r => this.uploaded.find(up => up.sub_type === doc.code && up.ref === r.id) === undefined);
    },
    getDocUploads: function (code) {
      return (this.uploaded || []).filter(du => du.sub_type === code).sort((a, b) => a.timeid - b.timeid);
    },
    updateDocuments: function () {
      this.getDocuments();

      // if (this.lead) {
        // if (!this.lead.highlights) {
        //   this.lead.highlights = [];
        // }
        //
        // let docUpd = this.lead.highlights.find(h => h.code === 'doc_updated' );
        //
        // if ( docUpd ) {
        //   docUpd.timeid = Date.now();
        // } else {
        //   this.lead.highlights.push({
        //     code: 'doc_updated',
        //     detail: "Updated",
        //     timeid: Date.now()
        //   });
        // }
        // this.updateCrmRecord([this.lead], null).then(res => {
        //   console.log(res);
        // });
      // }
    },
    getDocuments: function () {
      this.getAccountDocuments().then(res => {
        console.log(res);
        this.documents = res.data.documents;
        this.uploaded = res.data.uploaded;
      })
    },
    deleteDocument: function (doc) {
      this.deleteAccountDocument(doc).then(res => {
        console.log(res);
        // this.documents = res.data.documents;
        let idx = this.uploaded.indexOf(doc);
        if (idx >= 0) {
          this.uploaded.splice(idx, 1);
        }
      })
    }
  },
  mounted() {
    this.getDocuments();
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .article-box-large {
    min-height: 22em;
  }
  .article-box-small {
    min-height: 15em;
  }
}
</style>
